export default function CFunctionParameters() {
  return <h2>C Function Parameters</h2>;
}
